document.addEventListener('DOMContentLoaded', () => {
  const sections = document.querySelectorAll('.gstar-product');

  sections.forEach((section) => {
    const mediaItems = Array.from(
      section.querySelectorAll('.gstar-product__media')
    );

    const dots = Array.from(
      section.querySelectorAll('[data-gstar-dot]')
    );

    const prevButton = section.querySelector('[data-gstar-prev]');
    const nextButton = section.querySelector('[data-gstar-next]');
    const counter = section.querySelector('[data-current-media]');

    if (!mediaItems.length) return;

    let currentIndex = 0;

    const showMedia = (index) => {
      if (index < 0) {
        index = mediaItems.length - 1;
      }

      if (index >= mediaItems.length) {
        index = 0;
      }

      currentIndex = index;

      mediaItems.forEach((item, itemIndex) => {
        item.classList.toggle('is-active', itemIndex === currentIndex);
      });

      dots.forEach((dot, dotIndex) => {
        dot.classList.toggle('is-active', dotIndex === currentIndex);
      });

      if (counter) {
        counter.textContent = String(currentIndex + 1).padStart(2, '0');
      }
    };

    if (prevButton) {
      prevButton.addEventListener('click', () => {
        showMedia(currentIndex - 1);
      });
    }

    if (nextButton) {
      nextButton.addEventListener('click', () => {
        showMedia(currentIndex + 1);
      });
    }

    dots.forEach((dot, dotIndex) => {
      dot.addEventListener('click', () => {
        showMedia(dotIndex);
      });
    });

    section.addEventListener('keydown', (event) => {
      if (event.key === 'ArrowLeft') {
        showMedia(currentIndex - 1);
      }

      if (event.key === 'ArrowRight') {
        showMedia(currentIndex + 1);
      }
    });

    const productForm = section.querySelector('form[action*="/cart/add"]');

    if (productForm) {
      const optionInputs = Array.from(
        productForm.querySelectorAll('input[type="radio"][name^="options["]')
      );

      const variantInput = productForm.querySelector('[data-variant-id]');
      const addButton = productForm.querySelector('.gstar-product__add');

      const productDataScript = document.querySelector(
        `script[type="application/json"][data-product-json="${section.dataset.sectionId}"]`
      );

      let productData = null;

      if (productDataScript) {
        try {
          productData = JSON.parse(productDataScript.textContent);
        } catch (error) {
          console.warn('G* product data could not be parsed.', error);
        }
      }

      const getSelectedOptions = () => {
        const selected = {};

        optionInputs.forEach((input) => {
          if (input.checked) {
            selected[input.name] = input.value;
          }
        });

        return selected;
      };

      const findMatchingVariant = () => {
        if (!productData || !productData.variants) return null;

        const selectedOptions = getSelectedOptions();

        return productData.variants.find((variant) => {
          return variant.options.every((value, index) => {
            const optionName = productData.options[index];
            return selectedOptions[`options[${optionName}]`] === value;
          });
        });
      };

      const updateVariant = () => {
        const variant = findMatchingVariant();

        if (!variant) return;

        if (variantInput) {
          variantInput.value = variant.id;
        }

        if (addButton) {
          addButton.disabled = !variant.available;
          addButton.textContent = variant.available
            ? 'ADD TO CART'
            : 'SOLD OUT';
        }
      };

      optionInputs.forEach((input) => {
        input.addEventListener('change', updateVariant);
      });
    }

    showMedia(0);
  });
});